module.exports = __webpack_public_path__ + "static/media/bells.f9af3da0.jpg";